export const FETCH_MIPS = "[ADMIN] FETCH_MIPS";
export const FETCH_MIPS_START = "[ADMIN] FETCH_MIPS_START";
export const FETCH_MIPS_SUCCESS = "[ADMIN] FETCH_MIPS_SUCCESS";
export const FETCH_MIPS_ERROR = "[ADMIN] FETCH_MIPS_ERROR";

export const ADD_MIP = "[ADMIN] ADD_MIP";
export const ADD_MIP_SUCCESS = "[ADMIN] ADD_MIP_SUCCESS";
export const ADD_MIP_ERROR = "[ADMIN] ADD_MIP_ERROR";

export const UPDATE_MIP = "[ADMIN]  UPDATE_MIP";
export const  UPDATE_MIP_SUCCESS = "[ADMIN]  UPDATE_MIP_SUCCESS";
export const  UPDATE_MIP_ERROR = "[ADMIN]  UPDATE_MIP_ERROR";

export const fetchMip = (risId) => {
    return {
        type: FETCH_MIPS,
        risId
    };
};

export const fetchMipSuccess = (mips) => {
    return {
        type: FETCH_MIPS_SUCCESS,
        mips: mips
    };
};

export const fetchMipError = (error) => {
    return {
        type: FETCH_MIPS_ERROR,
        error: error
    };
};

export const addNewMip = (mip) => {
    return {
        type: ADD_MIP,
        mip
    };
};

export const updateMip = (mip) => {
    return {
        type: UPDATE_MIP,
        mip
    };
};
